/* eslint-disable no-unused-expressions */
import React, {
  createContext,
  useCallback,
  useState,
  useMemo,
  useRef
} from "react";
import Modals from "./Modals";

/** CONTEXT */
export const ModalContext = createContext(null);

/** PROVIDER */
export default function ModalProvider({ children }) {
  const id = useRef(0);
  const [modals, setModals] = useState([]);

  const openModal = useCallback(
    ({
      component,
      headerIcon,
      hideHeader,
      showDivider,
      modalHeader,
      showCloseIcon,
      onCloseIconClick,
      modalSubHeader,
      componentProps,
      pathIllustration
    }) => {
      id.current += 1;
      const modalItem = {
        id: id.current,
        component,
        headerIcon,
        hideHeader,
        showDivider,
        modalHeader,
        showCloseIcon,
        onCloseIconClick,
        componentProps,
        modalSubHeader,
        pathIllustration
      };

      setModals(currentModals => currentModals.concat(modalItem));
    },
    [modals]
  );

  const providerValue = useMemo(
    () => ({
      open: openModal
    }),
    [openModal]
  );

  return (
    <ModalContext.Provider value={providerValue}>
      <Modals modals={modals} />
      {children}
    </ModalContext.Provider>
  );
}
